export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11861.0b8dda6f.jpg";